import React from 'react';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import DatePickerField from '../Formik/DatePickerField';
import { Submit } from '../Formik/Submit';
import { Button } from '../utils/forms/Button';
import { find } from 'lodash';
function SharePlaceForm({ spotId, handleCancel, handleSubmit }) {
  const today = new Date();
  const place = useSelector((state) =>
    find(state.spots, (spot) => spot.placeId === spotId)
  );

  return (
    <div className="sharemodal">
      {place && (
        <div>
          <h2 className="text-center text-red">{place.place && place.place}</h2>
          <p className="text-center h4 mb3">
            V jakém termínu chcete sdílete stálé parkovací místo č.{' '}
            {place.place} uživatele {place.permanentUserName} ?
          </p>
        </div>
      )}
      <Formik
        initialValues={{
          dateFrom: today,
          dateTo: today
        }}
        onSubmit={handleSubmit}
      >
        <Form>
          <div className="sharemodal__form">
            <div className="sharemodal__date">
              <DatePickerField name="dateFrom" label="Vyberte termín od" />
            </div>
            <div className="">
              <DatePickerField name="dateTo" label="Do" />
            </div>
          </div>
          <div className="sharemodal__buttons">
            <Button type="button" color="secondary" onClick={handleCancel}>
              Zrušit
            </Button>
            <Submit value="Sdílet" />
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default SharePlaceForm;
